var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Route, Routes, Navigate } from 'react-router-dom';
import MessagePage from '../scenes/MessagePage';
import TemplatePage from '../scenes/TemplatePage';
import UserAdminPage from '../scenes/UserAdminPage';
import UserContainer from '../reducers/authentication';
import auth from '../lib/auth';
var StyledPage = styled.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 4rem 4rem 4rem;\n"], ["\n  padding: 0 4rem 4rem 4rem;\n"])));
var Main = function () {
    var _a = UserContainer.useContainer(), canReadTemplates = _a.canReadTemplates, canReadMessages = _a.canReadMessages;
    var isAuthenticated = auth.isAuthenticated;
    return (_jsx(StyledPage, { children: _jsx(Routes, { children: isAuthenticated &&
                _jsxs(_Fragment, { children: [canReadTemplates &&
                            _jsxs(_Fragment, { children: [_jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/admin/templates" }) }), _jsx(Route, { path: "/admin/templates/*", element: _jsx(TemplatePage, {}) })] }), canReadMessages &&
                            _jsx(Route, { path: "/admin/messages/*", element: _jsx(MessagePage, {}) }), canReadMessages && !canReadTemplates &&
                            _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/admin/messages" }) }), _jsx(Route, { path: "/admin/useradmin/*", element: _jsx(UserAdminPage, {}) })] }) }) }));
};
export default Main;
var templateObject_1;
